import PropTypes from 'prop-types';
import React from 'react';

import { translate as t } from '../../lib/I18n';
import Icon from '../general/Icon';
import BaseModal from '../general/BaseModal';

import Order from '../../records/Order';

function ExpiredModal ({ order, onClose }) {

    const modalProps = {
        disableBlur: true,
        disableEscape: true,
        className: "modal--sm basket-expired-modal",
        titleText: 'basket.expired',
        onClose: onClose,
        hideContinue: true,
        backdropClassName: "basket-expired-modal",
    };

    return (
        <BaseModal { ...modalProps }>
            <div className="alert-warning margin-top margin-bottom text-center">
                <Icon className="text-lg" icon="error" />
                <h3>{ t('basket.expired.chosenJourneys', { journeys: order.trips.size }) }</h3>
            </div>
            <p className="text-center">{ t('basket.expired.pleaseTryAgain') }</p>
        </BaseModal>
    );

}

ExpiredModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    order: PropTypes.instanceOf(Order).isRequired
};

export default ExpiredModal;
